module.exports = __webpack_public_path__ + "static/media/neutral_slightly-happy.4eed4a73.svg";